// extracted by mini-css-extract-plugin
export var backButton = "UserVerificationInfo-module--backButton--c9d19";
export var content = "UserVerificationInfo-module--content--ed53d";
export var email = "UserVerificationInfo-module--email--ab72a";
export var formWrapper = "UserVerificationInfo-module--formWrapper--41e6e";
export var header = "UserVerificationInfo-module--header--b5044";
export var listItems = "UserVerificationInfo-module--listItems--d5d2c";
export var resendLink = "UserVerificationInfo-module--resendLink--211b3";
export var submitButton = "UserVerificationInfo-module--submitButton--3f19d";
export var wrapper = "UserVerificationInfo-module--wrapper--5bb93";